import FrontLayout from "./components/layouts/FrontLayout/FrontLayout";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import { Slide, ToastContainer } from "react-toastify";
import AdminLayout from "./components/layouts/AdminLayout.js/AdminLayout";
import { Route, Routes } from "react-router-dom";
import { useEffect } from "react";
import { useState } from "react";
import Mobile from "./components/modules/mobile/Mobile";
import lang from "./assets/lang/icons.json";

axios.defaults.withCredentials = true;

axios.defaults.baseURL = `${lang.axiosUrl}`;
axios.defaults.headers.post["Content-type"] = "application/json";
axios.defaults.headers.post["Accept"] = "application/json";

axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem("auth_token");
  config.headers.authorization = token ? `Bearer ${token}` : "";
  return config;
});

function App() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const setWindowDimensions = () => {
    setWindowWidth(window.innerWidth);
  };
  useEffect(() => {
    window.addEventListener("resize", setWindowDimensions);
    return () => {
      window.removeEventListener("resize", setWindowDimensions);
    };
  }, [windowWidth]);

  return (
    <div className="App">
      {windowWidth > 1024 ? (
        <>
          <ToastContainer
            position="top-right"
            hideProgressBar
            theme="colored"
            limit={3}
            transition={Slide}
            autoClose={2000}
          />
          <Routes>
            <Route path="/admin/*" element={<AdminLayout />} />
            <Route path="/*" element={<FrontLayout />} />
          </Routes>
        </>
      ) : (
        <Mobile />
      )}
    </div>
  );
}

export default App;
